import React, { Component } from 'react';
import './App.css';
import Routing from './components/Routing.js';
import { Helmet } from "react-helmet";


class App extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Hoopstir</title>
          <link rel="icon" type="image/png" href="basketball.png" sizes="16x16" />
        </Helmet>
        <Routing />
      </div>
    );
  }
}

export default App;
